import axios from 'axios'

import {
  SET_ACTIVE_FILTERS,
  SET_PAGE_PARAMS,
  SAVE_USER_PREFS_COLUMNS_SUCCESS,
  SAVE_USER_PREFS_COLUMNS_FAILURE,
  GET_ALL_COLUMNS_SUCCESS,
  GET_ALL_COLUMNS_FAILURE,
  GET_USER_PREFS_COLUMNS_SUCCESS,
  GET_USER_PREFS_COLUMNS_FAILURE,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_FAILURE,
  SET_LAST_SEARCH_ID,
  GET_CONTACTS_STATS_SUCCESS,
  GET_CONTACT_STATS_FAILURE,
  GET_CONTACTS_CANCEL,
  GET_MOST_RECENT_SEARCH_SUCCESS,
  GET_MOST_RECENT_SEARCH_FAILURE,
  POST_MOST_RECENT_SEARCH_SUCCESS,
  POST_MOST_RECENT_SEARCH_FAILURE,
  UPDATE_PAGE_SIZE,
  GET_PAGE_SIZE_FAILURE,
  UPDATE_CONTACT_REQUESTED,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAILURE,
  GET_EVAL_FORMS_SUCCESS,
  GET_EVAL_FORMS_FAILURE,
  GET_RECORDING_TYPES_SUCCESS,
  GET_RECORDING_TYPES_FAILURE,
  GET_TIME_ZONES_SUCCESS,
  GET_TIME_ZONES_FAILURE,
  GET_METADATA_FIELDS_SUCCESS,
  GET_METADATA_FIELDS_FAILURE,
  START_LOADING,
  STOP_LOADING,
  START_DOWNLOADING,
  STOP_DOWNLOADING,
  CLEAR_ERRORS,
  SAVE_RECORDINGS_COLUMN_WIDTHS,
  GET_RECORDINGS_COLUMN_WIDTHS,
  UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_SAVE,
  UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_RESET,
} from './recordings.constants'
import api from './recordings.api'
import { getActiveSearchFilters, getPageParams } from './recordings.selectors'

import { CancelRequestError } from '../../Helpers/api'
import { AppThunk } from '../../root.reducer'

export const startLoading = () => ({
  type: START_LOADING,
}) as const
export const stopLoading = () => ({
  type: STOP_LOADING,
}) as const
export const startDownloading = (itemName: $TSFIXME) => ({
  type: START_DOWNLOADING,
  itemName,
}) as const
export const stopDownloading = () => ({
  type: STOP_DOWNLOADING,
}) as const
export const clearErrors = () => ({
  type: CLEAR_ERRORS,
}) as const

export const getAllColumnsSuccess = (columns: $TSFIXME) => ({
  type: GET_ALL_COLUMNS_SUCCESS,
  columns,
}) as const

export const getAllColumnsFailure = (error: $TSFIXME) => ({
  type: GET_ALL_COLUMNS_FAILURE,
  error,
}) as const

export const saveUserPrefsColumnsSuccess = (columns: $TSFIXME) => ({
  type: SAVE_USER_PREFS_COLUMNS_SUCCESS,
  columns,
}) as const

export const saveUserPrefsColumnsFailure = (error: $TSFIXME) => ({
  type: SAVE_USER_PREFS_COLUMNS_FAILURE,
  error,
}) as const

export const getUserPrefsColumnsSuccess = (columns: $TSFIXME) => ({
  type: GET_USER_PREFS_COLUMNS_SUCCESS,
  columns,
}) as const

export const getUserPrefsColumnsFailure = (error: $TSFIXME) => ({
  type: GET_USER_PREFS_COLUMNS_FAILURE,
  error,
}) as const

export const getContactsSuccess = (contacts: $TSFIXME, pageCursor: $TSFIXME) => ({
  type: GET_CONTACTS_SUCCESS,
  contacts,
  pageCursor,
}) as const

export const getContactsFailure = (error: $TSFIXME) => ({
  type: GET_CONTACTS_FAILURE,
  error,
}) as const

export const setLastSearchId = (id: $TSFIXME) => ({
  type: SET_LAST_SEARCH_ID,
  id,
}) as const

export const getContactsStatsSuccess = (stats: $TSFIXME, id: string) => ({
  type: GET_CONTACTS_STATS_SUCCESS,
  stats,
  id,
}) as const

export const getContactStatsFailure = (error: $TSFIXME, id: string) => ({
  type: GET_CONTACT_STATS_FAILURE,
  error,
  id,
}) as const

export const getContactsCancel = () => ({
  type: GET_CONTACTS_CANCEL,
}) as const

export const updateContactRequested = () => ({
  type: UPDATE_CONTACT_REQUESTED,
}) as const

export const updateContactSuccess = (contact: $TSFIXME) => ({
  type: UPDATE_CONTACT_SUCCESS,
  contact,
}) as const

export const updateContactFailure = (error: $TSFIXME) => ({
  type: UPDATE_CONTACT_FAILURE,
  error,
}) as const

export const getMostRecentSearchSuccess = (data: $TSFIXME) => ({
  data,
  type: GET_MOST_RECENT_SEARCH_SUCCESS,
}) as const

export const getMostRecentSearchError = (error: $TSFIXME) => ({
  error,
  type: GET_MOST_RECENT_SEARCH_FAILURE,
}) as const

export const postMostRecentSearchSuccess = (data: $TSFIXME) => ({
  data,
  type: POST_MOST_RECENT_SEARCH_SUCCESS,
}) as const

export const postMostRecentSearchError = (error: $TSFIXME) => ({
  error,
  type: POST_MOST_RECENT_SEARCH_FAILURE,
}) as const

export const updatePageSize = (data: $TSFIXME) => ({
  data,
  type: UPDATE_PAGE_SIZE,
}) as const

export const getPageSizeError = (error: $TSFIXME) => ({
  error,
  type: GET_PAGE_SIZE_FAILURE,
}) as const

export const getEvalFormsSuccess = (evalForms: $TSFIXME) => ({
  evalForms,
  type: GET_EVAL_FORMS_SUCCESS,
}) as const

export const getEvalFormsError = (error: $TSFIXME) => ({
  error,
  type: GET_EVAL_FORMS_FAILURE,
}) as const

export const getRecordingTypesSuccess = (recordingTypes: $TSFIXME) => ({
  recordingTypes,
  type: GET_RECORDING_TYPES_SUCCESS,
}) as const

export const getRecordingTypesError = (error: $TSFIXME) => ({
  error,
  type: GET_RECORDING_TYPES_FAILURE,
}) as const

export const getTimeZonesSuccess = (timeZones: $TSFIXME) => ({
  timeZones,
  type: GET_TIME_ZONES_SUCCESS,
}) as const

export const getTimeZonesError = (error: $TSFIXME) => ({
  error,
  type: GET_TIME_ZONES_FAILURE,
}) as const

export const getMetadataFieldsSuccess = (data: $TSFIXME) => ({
  data,
  type: GET_METADATA_FIELDS_SUCCESS,
}) as const

export const getMetadataFieldsError = (error: $TSFIXME) => ({
  error,
  type: GET_METADATA_FIELDS_FAILURE,
}) as const

export const setActiveFilters = (activeFilters: $TSFIXME) => ({
  type: SET_ACTIVE_FILTERS,
  activeFilters,
}) as const

export const setPageParams = (pageParams: $TSFIXME) => ({
  type: SET_PAGE_PARAMS,
  pageParams,
}) as const

export const saveColumnWidthsSuccess = (recordingsColumnWidths: $TSFIXME) => ({
  type: SAVE_RECORDINGS_COLUMN_WIDTHS,
  recordingsColumnWidths,
}) as const

export const getColumnWidthsSuccess = (recordingsColumnWidths: $TSFIXME) => ({
  type: GET_RECORDINGS_COLUMN_WIDTHS,
  recordingsColumnWidths,
}) as const

let cancel = axios.CancelToken.source()

export const getEvalForms = (): AppThunk => {
  return async dispatch => {
    try {
      const data = await api.getActiveEvalForms()
      dispatch(getEvalFormsSuccess(data))
    } catch (error) {
      dispatch(getEvalFormsError(error))
    }
  }
}

export const getMetadataFields = (): AppThunk => {
  return async dispatch => {
    try {
      const data = await api.getMetadataFields()
      dispatch(getMetadataFieldsSuccess(data))
    } catch (error) {
      dispatch(getMetadataFieldsError(error))
    }
  }
}

export const getAllColumns = (): AppThunk => {
  return async dispatch => {
    try {
      const columns = await api.getAllColumns()
      const success = getAllColumnsSuccess(columns)
      dispatch(success)
      return success
    } catch (e) {
      const failure = getAllColumnsFailure(e)
      dispatch(failure)
      return failure
    }
  }
}

export const saveUserPrefsColumns = (data: $TSFIXME): AppThunk => {
  return async dispatch => {
    try {
      const columns = await api.saveUserPrefsColumns(data)
      const success = saveUserPrefsColumnsSuccess(columns)
      dispatch(success)
      return success
    } catch (e) {
      const failure = saveUserPrefsColumnsFailure(e)
      dispatch(failure)
      return failure
    }
  }
}

export const getUserPrefsColumns = (): AppThunk => {
  return async dispatch => {
    try {
      const columns = await api.getUserPrefsColumns()
      const success = getUserPrefsColumnsSuccess(columns)
      dispatch(success)
      return success
    } catch (e) {
      const failure = getUserPrefsColumnsFailure(e)
      dispatch(failure)
      return failure
    }
  }
}

export const saveColumnWidths = (columns: $TSFIXME[]): AppThunk => {
  return dispatch => {
    const newColumnWidths = columns.reduce((columnWidths, column) => {
      columnWidths[column.name] = column.width
      return columnWidths
    }, {})

    const recordingsColumnWidths = api.getColumnWidthsFromLocalStorage()

    const updatedColumnWidths = { ...recordingsColumnWidths, ...newColumnWidths }

    api.saveColumnWidthsToLocalStorage(updatedColumnWidths)

    dispatch(saveColumnWidthsSuccess(updatedColumnWidths))
  }
}

export const getColumnWidths = (): AppThunk => {
  return dispatch => dispatch(getColumnWidthsSuccess(api.getColumnWidthsFromLocalStorage()))
}

export const getMostRecentSearch = (): AppThunk => {
  return async dispatch => {
    try {
      const data = await api.getMostRecentSearch()
      const success = getMostRecentSearchSuccess(data)
      dispatch(success)
      return success
    } catch (error) {
      const failure = getMostRecentSearchError(error)
      dispatch(failure)
      return failure
    }
  }
}

export const postMostRecentSearch = (params: $TSFIXME): AppThunk => {
  return async dispatch => {
    try {
      const data = await api.postMostRecentSearch(params)
      const success = postMostRecentSearchSuccess(data)
      dispatch(success)
      return success
    } catch (error) {
      const failure = postMostRecentSearchError(error)
      dispatch(failure)
      return failure
    }
  }
}

export const getPageSize = (): AppThunk => {
  return async dispatch => {
    try {
      const data = await api.getPageSize()
      if (data.pageSize) {
        const success = updatePageSize(data)
        dispatch(success)
        return success
      } else {
        return null
      }
    } catch (error) {
      const failure = getPageSizeError(error)
      dispatch(failure)
      return failure
    }
  }
}

export const savePageSize = (data: $TSFIXME) => {
  return async () => {
    api.postPageSize(data)
  }
}

// pages are 0-indexed; rangea are 1 - x
const getPage = (range: $TSFIXME) => {
  const rowsPerPage = range.rangeTop - range.rangeBottom + 1
  return (range.rangeBottom - 1) / rowsPerPage
}

export const getContactsFromQueryParams = (queryParams: $TSFIXME, range: $TSFIXME, contactSearchPageCursors: $TSFIXME): AppThunk => {
  return async dispatch => {
    try {
      const page = getPage(range)
      const { contacts, nextPageCursor } = await api.getContactsFromQueryParams(queryParams, range, cancel, contactSearchPageCursors[page])
      const success = getContactsSuccess(contacts, { page: page + 1, nextPageCursor })      // set the cursor for the next page
      dispatch(success)
      return success
    } catch (e) {
      if (e instanceof CancelRequestError) {
        const cancel = getContactsCancel()
        dispatch(cancel)
        return cancel
      } else {
        const failure = getContactsFailure(e)
        dispatch(failure)
        return failure
      }
    }
  }
}

export const getContacts = (searchParams: $TSFIXME, range: $TSFIXME, contactSearchPageCursors: $TSFIXME): AppThunk => {
  return async dispatch => {
    try {
      const page = getPage(range)
      const { contacts, nextPageCursor } = await api.getContacts(searchParams, range, cancel, contactSearchPageCursors[page])
      const contactsSuccess = getContactsSuccess(contacts, { page: page + 1, nextPageCursor })            // set the cursor for the next page
      dispatch(contactsSuccess)
      return contactsSuccess
    } catch (e) {
      if (e instanceof CancelRequestError) {
        const cancel = getContactsCancel()
        dispatch(cancel)
        return cancel
      } else {
        const failure = getContactsFailure(e)
        dispatch(failure)
        return failure
      }
    }
  }
}

export const getContactStats = (searchParams: $TSFIXME): AppThunk => {
  return async dispatch => {
    // Set the ID for the search in state so we can later check whether this is the most recent stats call
    const searchId = self.crypto.randomUUID()
    await dispatch(setLastSearchId(searchId))
    try {
      const stats = await api.getContactsStats(searchParams, cancel)
      const statsSuccess = getContactsStatsSuccess(stats, searchId)
      dispatch(statsSuccess)
      return statsSuccess
    } catch (e) {
      const failure = getContactStatsFailure(e, searchId)
      dispatch(failure)
      return failure
    }
  }
}

export const updateContact = (contact: $TSFIXME): AppThunk => {
  return async dispatch => {
    dispatch(updateContactRequested())
    try {
      const updatedContact = await api.updateContact(contact)

      dispatch(updateContactSuccess(updatedContact))
    } catch (error) {
      dispatch(updateContactFailure(error))
    }
  }
}

export const updateRecordingsContactsAfterEvaluationSave = (payload: $TSFIXME, contactId: $TSFIXME) => ({
  payload,
  contactId,
  type: UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_SAVE,
}) as const

export const updateRecordingsContactsAfterEvaluationReset = (contactId: $TSFIXME) => ({
  contactId,
  type: UPDATE_RECORDINGS_CONTACTS_AFTER_EVALUATION_RESET,
}) as const

export const getInitialContacts = (): AppThunk => {
  return async (dispatch, getState) => {
    const recentSearch = dispatch(getMostRecentSearch())
    await recentSearch
    const recordings = getState().recordings
    const activeFilters = getActiveSearchFilters(recordings)
    const pageParams = getPageParams(recordings)
    await dispatch(setPageParams({ ...pageParams, cachedFilters: structuredClone(activeFilters) }))
    // Kick off stats search, but don't await it so that it doesn't block the UI loading
    dispatch(getContactStats(activeFilters))
    return await dispatch(getContacts(activeFilters, pageParams, []))     // initial load, so no cursors
  }
}

export const downloadCsvExport = (itemName: $TSFIXME): AppThunk => {
  return async (dispatch, getState) => {
    const filters = getActiveSearchFilters(getState().recordings)
    dispatch(startDownloading(itemName)) // TODO: i18n
    await api.downloadCSV(filters)
    dispatch(stopDownloading())
  }
}

export const cancelGetContacts = () => {
  cancel.cancel('Operation canceled by the user.')
  cancel = axios.CancelToken.source()
  return getContactsCancel()
}

export type RecordingsAction = ReturnType<
  | typeof startLoading
  | typeof stopLoading
  | typeof startDownloading
  | typeof stopDownloading
  | typeof clearErrors
  | typeof getAllColumnsSuccess
  | typeof getAllColumnsFailure
  | typeof saveUserPrefsColumnsSuccess
  | typeof saveUserPrefsColumnsFailure
  | typeof getUserPrefsColumnsSuccess
  | typeof getUserPrefsColumnsFailure
  | typeof getContactsSuccess
  | typeof getContactsFailure
  | typeof getContactsStatsSuccess
  | typeof getContactStatsFailure
  | typeof getContactsCancel
  | typeof updateContactRequested
  | typeof updateContactSuccess
  | typeof updateContactFailure
  | typeof getMostRecentSearchSuccess
  | typeof getMostRecentSearchError
  | typeof postMostRecentSearchSuccess
  | typeof postMostRecentSearchError
  | typeof updatePageSize
  | typeof getPageSizeError
  | typeof getEvalFormsSuccess
  | typeof getEvalFormsError
  | typeof getRecordingTypesSuccess
  | typeof getRecordingTypesError
  | typeof getTimeZonesSuccess
  | typeof getTimeZonesError
  | typeof getMetadataFieldsSuccess
  | typeof getMetadataFieldsError
  | typeof setActiveFilters
  | typeof setPageParams
  | typeof saveColumnWidthsSuccess
  | typeof getColumnWidthsSuccess
  | typeof updateRecordingsContactsAfterEvaluationSave
  | typeof updateRecordingsContactsAfterEvaluationReset
  | typeof setLastSearchId
>
